import { Box, Typography, Divider } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"

import Image from "components/landing/image"

import { Description } from "../components"

const ImageTextBlock = ({ data, description, titlebar, strapStyle }) => (
  <Box mb={6} mx={{ _: 0, tablet: 6 }} textAlign="center">
    {titlebar && (
      <>
        <Divider bg="black" mb={5} />
        <Typography fontSize={20} mb={3}>
          {titlebar}
        </Typography>
      </>
    )}
    <Description>{description}</Description>
    <Box
      display={{
        _: strapStyle ? "flex" : "block",
        tablet: "flex",
      }}
      flexWrap="wrap"
      justifyContent={{
        _: "center",
        tablet: strapStyle ? "center" : "flex-start",
      }}
      mx={{ _: 2, desktop: 7 }}
    >
      {data.map((item) => (
        <Box
          flex={{
            _: "0 1  27%",
            tablet: strapStyle ? "0 1 20%" : "0 1 50%",
          }}
          key={item.text}
          mx={{ _: 1, tablet: 0 }}
          px={{ tablet: data.length > 4 ? 2 : 0 }}
        >
          <Image image={item.image} />
          <Typography fontSize={18} mb={3}>
            {item.text}
          </Typography>
        </Box>
      ))}
    </Box>
  </Box>
)

ImageTextBlock.propTypes = {
  data: PropTypes.array,
  description: PropTypes.string,
  strapStyle: PropTypes.bool,
  titlebar: PropTypes.string,
}

export default ImageTextBlock
